import { ChangeDetectorRef, inject } from '@angular/core';
import { ModalService } from '@seahorse/temp';

export interface BroadcastMessageModel {
  type: BroadcastMessageType;
  message: string;
}

export const BROADCAST_MESSAGE_TYPES = ['info', 'warning', 'error'] as const;

export type BroadcastMessageType = typeof BROADCAST_MESSAGE_TYPES[number];

export const BROADCAST_MESSAGE_TYPE_CLASSES: Record<
  BroadcastMessageType,
  string
> = {
  info: 'fa fa-info-circle text-info',
  warning: 'fa fa-exclamation-triangle text-warning',
  error: 'fa fa-times-circle text-danger',
};

export const broadcastModal = () => {
  const modalService = inject(ModalService);

  const icon = document.createElement('i');
  icon.setAttribute('style', 'font-size:2.5rem;margin-right:1rem;');

  const text = document.createElement('span');
  const wrapper = document.createElement('div');
  wrapper.setAttribute(
    'style',
    'display:flex;align-items:center;padding:.5rem;'
  );

  wrapper.appendChild(icon);
  wrapper.appendChild(text);

  return (message: BroadcastMessageModel) => {
    icon.className = BROADCAST_MESSAGE_TYPE_CLASSES[message.type];
    text.innerText = message.message;

    return modalService
      .buildModal()
      .withTitle('systemMessage.importantMessage')
      .withHtmlBody(wrapper)
      .open({
        hideActions: true,
      });
  };
};
